import { HorarioModel } from '@/store/catalogos/horario.model';
import { ApiResponse } from '@/store/students/apiResponse.model';
import { properties } from '@/utils/properties';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StudentsService {

  constructor(private http: HttpClient) { }
  
  calendar(p:number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(properties.URL_STUDENTS + 'inscripcion/calendario/alumno/'+ p, properties.httpOptions);
  }
  
  asistenciasPorHorario(p): Observable<HorarioModel> {
    return this.http.post<HorarioModel>(properties.URL_CATALOGS + 'asistencia/alumnos-horario', p, properties.httpOptions);
  }

  getFoto(): Observable<any> {
    return this.http.get<any>(properties.URL_STUDENTS + 'foto-alumno', properties.httpOptions);
  }

  cambiarPassword(p: { password: string, password_confirmation: string }): Observable<any> {
    return this.http.post<any>(properties.URL_STUDENTS + 'cambiar-password-alumno', p, properties.httpOptions);
  }

}
